<template>
  <div class="home">
    <!-- Hero Banner -->
    <section class="hero">
      <div class="hero-bg">
        <img src="/logo_gif.gif" alt="宠物星系" class="hero-bg-gif">
      </div>
      <div class="hero-content">
        <h1>宠物星系</h1>
        <p class="subtitle">为每一只回到母星的毛孩子建立永恒档案</p>
        <div class="hero-actions">
          <router-link to="/memorial" class="btn-primary">进入纪念馆</router-link>
          <router-link to="/brand" class="btn-secondary">了解更多</router-link>
        </div>
      </div>
    </section>

    <!-- 核心服务 -->
    <section class="services">
      <div class="container">
        <h2 class="section-title">我们的服务</h2>
        <div class="services-grid">
          <div class="service-card">
            <div class="service-icon">🌟</div>
            <h3>宠星纪念馆</h3>
            <p>为离世的宠物建立专属纪念空间，永久保存珍贵回忆</p>
            <router-link to="/memorial" class="service-link">了解更多 →</router-link>
          </div>
          <div class="service-card">
            <div class="service-icon">🎁</div>
            <h3>纪念好物</h3>
            <p>精选宠物纪念品，让爱以另一种方式延续</p>
            <router-link to="/shop" class="service-link">了解更多 →</router-link>
          </div>
          <div class="service-card">
            <div class="service-icon">💝</div>
            <h3>品牌理念</h3>
            <p>用心守护每一份人宠情谊，传递温暖与治愈</p>
            <router-link to="/brand" class="service-link">了解更多 →</router-link>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据统计 -->
    <section class="stats">
      <div class="container">
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-number">10,000+</div>
            <div class="stat-label">已入驻宠星</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">50,000+</div>
            <div class="stat-label">珍贵回忆</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">98%</div>
            <div class="stat-label">用户满意度</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 关于我们 -->
    <section class="about">
      <div class="container">
        <div class="about-content">
          <div class="about-text">
            <h2>关于宠物星系</h2>
            <p>宠物星系成立于2023年，是一个专注于宠物纪念服务的品牌。我们相信每一只宠物都是独一无二的星辰，在属于它们的星系中闪耀。</p>
            <p>我们致力于为宠物主提供一个记录、分享和纪念宠物生活的平台，让每一个珍贵瞬间都能被永久珍藏。</p>
            <router-link to="/brand" class="btn-outline">了解品牌故事</router-link>
          </div>
          <div class="about-image">
            <div class="image-placeholder">
              <span>🐕 🐈</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="cta">
      <div class="container">
        <h2>让爱永恒延续</h2>
        <p>为您的爱宠建立专属纪念空间，让回忆永远闪耀</p>
        <router-link to="/memorial" class="btn-primary">立即开始</router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style scoped>
/* 星空主题配色变量 */
:root {
  --primary-dark: #0f0c29;
  --primary-mid: #302b63;
  --primary-light: #24243e;
  --accent-purple: #7b68ee;
  --accent-blue: #5f9ea0;
  --accent-pink: #e6a8d7;
  --text-light: #f8f9fa;
  --text-muted: rgba(255, 255, 255, 0.7);
}

.home {
  padding-top: 70px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Hero Section - GIF 背景 */
.hero {
  min-height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding: 60px 20px;
}

.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
}

.hero-bg-gif {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.15;
  filter: blur(3px) brightness(0.8);
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(123, 104, 238, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(230, 168, 215, 0.1) 0%, transparent 40%);
  pointer-events: none;
  z-index: 1;
}

.hero-content {
  text-align: center;
  z-index: 2;
  max-width: 700px;
  position: relative;
}

.hero h1 {
  font-size: 4.5rem;
  color: #fff;
  margin-bottom: 25px;
  font-weight: 700;
  letter-spacing: 4px;
  text-shadow:
    0 0 60px rgba(123, 104, 238, 0.9),
    0 0 120px rgba(123, 104, 238, 0.5),
    0 4px 8px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 1.4rem;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 50px;
  line-height: 1.8;
  text-shadow:
    0 0 30px rgba(123, 104, 238, 0.8),
    0 0 60px rgba(0, 0, 0, 0.5),
    0 2px 4px rgba(0, 0, 0, 0.3);
  letter-spacing: 1px;
}

.hero-actions {
  display: flex;
  gap: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

/* 主按钮 - 紫罗兰渐变 */
.btn-primary {
  padding: 15px 40px;
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  color: #fff;
  text-decoration: none;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
  box-shadow: 0 4px 15px rgba(123, 104, 238, 0.4);
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(123, 104, 238, 0.6);
}

/* 次按钮 - 透明边框 */
.btn-secondary {
  padding: 15px 40px;
  background: transparent;
  color: #fff;
  text-decoration: none;
  border-radius: 30px;
  font-size: 1rem;
  font-weight: 600;
  border: 2px solid rgba(123, 104, 238, 0.5);
  transition: all 0.3s ease;
  display: inline-block;
}

.btn-secondary:hover {
  background: rgba(123, 104, 238, 0.2);
  border-color: #7b68ee;
  box-shadow: 0 0 20px rgba(123, 104, 238, 0.3);
}

.hero-visual {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.planet {
  position: absolute;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(123, 104, 238, 0.2), transparent);
  top: 50%;
  right: -100px;
  transform: translateY(-50%);
  animation: float 6s ease-in-out infinite;
}

.stars {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(2px 2px at 20px 30px, rgba(255,255,255,0.4), transparent),
    radial-gradient(2px 2px at 40px 70px, rgba(255,255,255,0.3), transparent),
    radial-gradient(1px 1px at 90px 40px, rgba(255,255,255,0.4), transparent),
    radial-gradient(2px 2px at 160px 120px, rgba(255,255,255,0.3), transparent),
    radial-gradient(1px 1px at 230px 80px, rgba(255,255,255,0.4), transparent);
  background-repeat: repeat;
  background-size: 250px 150px;
  animation: twinkle 4s ease-in-out infinite;
}

@keyframes float {
  0%, 100% { transform: translateY(-50%) translateX(0); }
  50% { transform: translateY(-50%) translateX(-20px); }
}

@keyframes twinkle {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

/* Services Section - 浅色背景 */
.services {
  padding: 100px 0;
  background: linear-gradient(180deg, #f8f7ff 0%, #ffffff 100%);
}

.section-title {
  text-align: center;
  font-size: 2.5rem;
  color: #302b63;
  margin-bottom: 60px;
  font-weight: 600;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;
}

.service-card {
  text-align: center;
  padding: 50px 30px;
  border-radius: 20px;
  background: #fff;
  transition: all 0.3s ease;
  border: 1px solid rgba(123, 104, 238, 0.1);
  box-shadow: 0 4px 20px rgba(48, 43, 99, 0.05);
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(123, 104, 238, 0.15);
  border-color: rgba(123, 104, 238, 0.2);
}

.service-icon {
  font-size: 3.5rem;
  margin-bottom: 25px;
}

.service-card h3 {
  font-size: 1.4rem;
  color: #302b63;
  margin-bottom: 15px;
  font-weight: 600;
}

.service-card p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 25px;
}

.service-link {
  color: #7b68ee;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.service-link:hover {
  color: #9d7bff;
  text-shadow: 0 0 10px rgba(123, 104, 238, 0.3);
}

/* Stats Section - 紫蓝渐变 */
.stats {
  padding: 80px 0;
  background: linear-gradient(135deg, #302b63 0%, #7b68ee 100%);
  position: relative;
  overflow: hidden;
}

.stats::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 10% 50%, rgba(230, 168, 215, 0.15) 0%, transparent 40%);
  pointer-events: none;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 60px;
  text-align: center;
  position: relative;
  z-index: 1;
}

.stat-number {
  font-size: 3.5rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  text-shadow: 0 0 30px rgba(255, 255, 255, 0.3);
}

.stat-label {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
}

/* About Section */
.about {
  padding: 100px 0;
  background: #fff;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

.about-text h2 {
  font-size: 2.5rem;
  color: #302b63;
  margin-bottom: 30px;
  font-weight: 600;
}

.about-text p {
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
  font-size: 1.05rem;
}

.btn-outline {
  padding: 12px 30px;
  border: 2px solid #7b68ee;
  color: #7b68ee;
  text-decoration: none;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.3s ease;
  display: inline-block;
  margin-top: 20px;
}

.btn-outline:hover {
  background: linear-gradient(135deg, #7b68ee 0%, #9d7bff 100%);
  color: #fff;
  box-shadow: 0 4px 15px rgba(123, 104, 238, 0.4);
}

.about-image {
  display: flex;
  justify-content: center;
  align-items: center;
}

.image-placeholder {
  width: 400px;
  height: 300px;
  background: linear-gradient(135deg, #f0edff 0%, #e8e4f8 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5rem;
  box-shadow: 0 10px 40px rgba(123, 104, 238, 0.1);
}

/* CTA Section - 深空背景 */
.cta {
  padding: 100px 0;
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 100%);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.cta::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 50% 50%, rgba(123, 104, 238, 0.1) 0%, transparent 60%);
  pointer-events: none;
}

.cta h2 {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 600;
  position: relative;
  z-index: 1;
}

.cta p {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.2rem;
  margin-bottom: 40px;
  position: relative;
  z-index: 1;
}

/* Responsive */
@media (max-width: 968px) {
  .hero h1 {
    font-size: 2.8rem;
  }

  .services-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-content {
    grid-template-columns: 1fr;
    gap: 50px;
  }

  .about-image {
    order: -1;
  }

  .image-placeholder {
    width: 100%;
    max-width: 350px;
    height: 250px;
  }
}

@media (max-width: 600px) {
  .hero h1 {
    font-size: 2.2rem;
  }

  .hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .btn-primary,
  .btn-secondary {
    width: 200px;
    text-align: center;
  }

  .section-title,
  .about-text h2,
  .cta h2 {
    font-size: 1.8rem;
  }

  .stat-number {
    font-size: 2.5rem;
  }
}
</style>
